/** @jsxImportSource @emotion/react */
import { Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

export const SubHeader: FC<PropsWithChildren> = ({ children }) => (
  <Typography variant={'18_24_700'} mb={18}>
    {children}
  </Typography>
);
